import { Row, Col, Checkbox, Radio, Input, Spin, Collapse, Typography, Card } from 'antd'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose'

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle,
  InfoWindow
} from 'react-google-maps'
import CardComponent from '../../../../components/CardComponent'
import { GOOGLE_MAP_API_URL, DEFAULT_LOCATION } from '../../../../config'
import { getHeroType } from '../../../../utils/index'
import { useDeepEffect } from '../../../../utils/hooks'
import { styles } from './styles'
import styled from 'styled-components'
import _ from 'lodash'
import axios from 'axios'
import { ButtonEx } from './index.style'
import { CollapseEx } from '../../../../styles/shared.style'
import { ENDPOINT } from '../../../../utils/constants'
import { SelectItem } from '../../../../styles/shared.style'

const endpoint = process.env.REACT_APP_API_ENDPOINT
const SideMapDiv = styled.div`
  height: auto;
  background-color: white;
  border-radius: 3px;
  position: absolute;
  width: 425px;
  top: 170px;
  left: 30px;
  padding: 15px;
  z-index: 10;
`

const SideMap = ({ setLocations, categories }) => {
  const [productIdList, setProductIdList] = useState([])
  const [typeId, setTypeId] = useState([])
  const [heroTypeList, setHeroTypeList] = useState([])
  const [showAppUser, setShowAppUser] = useState(false)
  const [showRadius, setShowRadius] = useState(false)
  const [showShop, setShowShop] = useState('1')
  const [loading, setLoading] = useState(false)
  const [stateList, setStateList] = useState([])

  useDeepEffect(() => {
    setStateList((prevState) => {
      categories.forEach((category) => {
        prevState.push({
          categoryId: category.categoryId,
          categoryName: category.categoryName,
          materials: category.materialList
        })
      })
      return [...prevState]
    })
  }, [categories])

  const onChange = (e) => {
    setShowShop(e.target.value)
  }

  function onClickItem(material) {
    const added = _.some(productIdList, (item) => {
      return item.id === material.id
    })

    if (added) {
      setProductIdList((prevState) => {
        const arr = prevState.filter((item) => item.id !== material.id)
        return [...arr]
      })
    } else {
      setProductIdList((prevState) => {
        prevState.push(material)
        return [...prevState]
      })
    }
  }

  function onClickTypeItem(type) {
    const added = _.some(heroTypeList, (item) => {
      return item === type
    })

    if (added) {
      setHeroTypeList((prevState) => {
        const arr = prevState.filter((item) => item !== type)
        return [...arr]
      })
    } else {
      setHeroTypeList((prevState) => {
        prevState.push(type)
        return [...prevState]
      })
    }
  }

  function onSearch(value) {
    if (value) {
      categories.forEach((category) => {
        setStateList((prevState) => {
          prevState.forEach((item) => {
            if (category.categoryId === item.categoryId) {
              const arr = _.filter(category.materialList, (material) => {
                return material.name.includes(value)
              })
              console.log('arr', arr)
              item.materials = arr
            }
          })

          return [...prevState]
        })
      })
    } else {
      setStateList((prevState) => {
        categories.forEach((product) => {
          prevState.forEach((item) => {
            if (product.categoryId === item.categoryId) {
              item.materials = product.materialList
            }
          })
        })

        return [...prevState]
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false

    if (!_.isEmpty(productIdList)) {
      active = productIdList.some((product) => {
        return product.id === item.id
      })
    }

    return active
  }

  const renderTypeItemActive = (item) => {
    let active = false

    if (!_.isEmpty(heroTypeList)) {
      active = heroTypeList.some((type) => {
        return type === item
      })
    }

    return active
  }

  const renderCategoryActive = (id) => {
    let active = false

    typeId.forEach((item) => {
      if (item === id) {
        active = true
      }
    })

    return active
  }

  const renderActiveAll = () => {
    let active = false

    if (typeId.length === categories.length) {
      active = true
    }

    return active
  }

  const onClickAll = () => {
    if (!_.isEmpty(typeId)) {
      if (typeId.length === categories.length) {
        setTypeId([])
        setProductIdList([])
      } else {
        categories.forEach((category) => {
          const findId = _.some(typeId, (item) => {
            return item === category.categoryId
          })
          if (!findId) {
            setTypeId((prevState) => {
              prevState.push(category.categoryId)
              return [...prevState]
            })

            setProductIdList((prevState) => {
              category.materialList.forEach((item) => {
                prevState.push(item)
              })
              return [...prevState]
            })
          }
        })
      }
    } else {
      const typeIds = categories.map((item) => item.categoryId)
      setTypeId(typeIds)

      setProductIdList((prevState) => {
        categories.forEach((category) => {
          category.materialList.forEach((item) => {
            prevState.push(item)
          })
        })
        return [...prevState]
      })
    }
  }

  const onClickCategory = (category) => {
    const findId = _.some(typeId, (item) => {
      return item === category.categoryId
    })

    if (findId) {
      const arr = _.remove(typeId, (item) => {
        return item !== category.categoryId
      })
      setTypeId(arr)

      setProductIdList((prevState) => {
        category.materials.forEach((material) => {
          _.remove(prevState, (item) => {
            return item.id === material.id
          })
        })
        return [...prevState]
      })
    } else {
      setTypeId((prevState) => {
        prevState.push(category.categoryId)
        return [...prevState]
      })

      setProductIdList((prevState) => {
        category.materials.forEach((item) => {
          prevState.push(item)
        })
        return [...prevState]
      })
    }
  }

  const onChangeShowAppUser = (e) => {
    setShowAppUser(e.target.checked)
  }

  const onChangeShowRadius = (e) => {
    setShowRadius(e.target.checked)
  }

  const onClearSearch = (e) => {
    e.preventDefault()
    setProductIdList([])
  }

  const onClickSearch = async (e) => {
    e.preventDefault()
    await setLoading(true)
    const data = {
      heroTypeList: heroTypeList,
      materialIdList: productIdList.map((item) => item.id),
      showAppUser: showAppUser || showRadius
    }

    const res = await axios.post(endpoint + `/map/search`, data)
    await setLoading(false)
    const locationList = res.data
    locationList.forEach((item) => {
      item.showShop = true
      if (item.user) {
        if (!showAppUser) {
          item.showShop = false
        } else if (!showRadius) {
          item.radius = 0
        }
      } else {
        if (showShop === '2') {
          item.radius = 0
        } else if (showShop === '3') {
          item.showShop = false
        }
      }
    })

    setLocations(locationList)
  }

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <SideMapDiv>
      <Spin spinning={loading} tip="กำลังโหลดข้อมูล Hero">
        <Row gutter={[8, 16]}>
          <Col span={24}>
            <CardComponent>
              <p>ผู้สร้างขยะ (User)</p>
              <Checkbox onChange={onChangeShowAppUser}>
                แสดงสัญลักษณ์ผู้สร้างขยะ
              </Checkbox>
              <Checkbox onChange={onChangeShowRadius}>
                แสดงรัศมีผู้สร้างขยะ
              </Checkbox>
            </CardComponent>
          </Col>
          <Col span={24}>
            <CardComponent>
              <Row gutter={8}>
                <Col span={8}>
                  <SelectItem
                    onClick={() => onClickTypeItem('RECYCLE_SHOP')}
                    active={renderTypeItemActive('RECYCLE_SHOP')}>
                    ร้านรับซื้อ
                  </SelectItem>
                </Col>
                <Col span={8}>
                  <SelectItem
                    onClick={() => onClickTypeItem('SCOOTER')}
                    active={renderTypeItemActive('SCOOTER')}>
                    รถรับซื้อ
                  </SelectItem>
                </Col>
                <Col span={8}>
                  <SelectItem
                    onClick={() => onClickTypeItem('DROP_POINT')}
                    active={renderTypeItemActive('DROP_POINT')}>
                    จุดรับ
                  </SelectItem>
                </Col>
              </Row>
              <Radio.Group onChange={onChange} defaultValue="1">
                <Radio style={radioStyle} value="1">แสดงสัญลักษณ์และรัศมีผู้รับขยะ</Radio>
                <Radio style={radioStyle} value="2">แสดงสัญลักษณ์ผู้รับขยะ</Radio>
                <Radio style={radioStyle} value="3">แสดงรัศมีของผู้รับขยะ</Radio>
              </Radio.Group>
            </CardComponent>
          </Col>
          <Col span={24}>
            <CollapseEx expandIconPosition="right">
              <Collapse.Panel key="1" header="วัสดุที่รับ">
                <CardComponent
                  style={{ marginTop: 10, height: 260, overflowY: 'scroll' }}>
                  <Input.Search
                    allowClear
                    placeholder="ค้นหา"
                    onSearch={onSearch}
                  />
                  <CardComponent>
                    <Row gutter={16} justify="center">
                      <SelectItem
                        onClick={() => onClickAll()}
                        active={renderActiveAll()}>
                        ทั้งหมด
                      </SelectItem>
                      {!_.isEmpty(stateList) &&
                        stateList.map((item, index) => {
                          return (
                            <SelectItem
                              key={index}
                              onClick={() => onClickCategory(item)}
                              active={renderCategoryActive(item.categoryId)}>
                              {item.categoryName
                                .toString()
                                .substring(
                                  4,
                                  item.categoryName.toString().length
                                )}
                            </SelectItem>
                          )
                        })}
                    </Row>
                  </CardComponent>
                  {!_.isEmpty(stateList) &&
                    stateList.map((item, index) => {
                      return (
                        <Row key={index} style={{ marginTop: 10 }}>
                          {item.materials.map((material, idx) => {
                            return (
                              <SelectItem
                                key={idx}
                                active={renderItemActive(material)}
                                onClick={() => onClickItem(material)}>
                                {material.name}
                              </SelectItem>
                            )
                          })}
                        </Row>
                      )
                    })}
                </CardComponent>
              </Collapse.Panel>
            </CollapseEx>
          </Col>
          <Col span={24}>
            <Row type="flex" justify="center">
              <Col span={4}>
                <ButtonEx
                  style={{ background: "#707070", color: "white" }}
                  onClick={(e) => onClearSearch(e)}>
                  ล้าง
                </ButtonEx>
              </Col>
              <Col span={4}>
                <ButtonEx
                  style={{ background: "#6ebf4b", color: "white" }}
                  onClick={(e) => onClickSearch(e)}>
                  แสดง
                </ButtonEx>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </SideMapDiv>
  )
}

export const HeroLocations = () => {
  const [open, setOpen] = useState(false)
  const [locations, setLocations] = useState([])
  const [categories, setCategories] = useState([])

  async function fetchData() {
    const res = await axios.get(ENDPOINT + `/product/groupByCategory`)
    setCategories(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  return (
    <GoogleMap defaultZoom={10} center={DEFAULT_LOCATION}>
      {!_.isEmpty(locations) &&
        locations.map((location, index) => (
          <div key={index.toString()}>
            {location.showShop && (
              <Marker
                position={{
                  lat: parseFloat(location.latitude),
                  lng: parseFloat(location.longitude)
                }}
                icon={getHeroType(location.heroType).icon}>
                {open === location.id && (
                  <InfoWindow onCloseClick={() => setOpen(false)}>
                    <Card square style={{ width: 400 }}>
                      <div style={styles.productWraper}>
                        <Typography gutterBottom variant="h6" component="h6">
                          {`${location.name} (${getHeroType(location.heroType).title
                            })`}
                        </Typography>
                      </div>
                      {/* <Typography variant="body1" component="p" gutterBottom> */}
                      {/*  {location.address} */}
                      {/* </Typography> */}

                      {/* <Typography>วัสดุที่รับ:</Typography> */}

                      {/* <div style={styles.productWraper}> */}
                      {/*  {location.hero.products.map((product, index) => ( */}
                      {/*    <Typography key={product.id}> */}
                      {/*      {index > 0 && ','} */}
                      {/*      {product.material.name} */}
                      {/*    </Typography> */}
                      {/*  ))} */}
                      {/* </div> */}
                    </Card>
                  </InfoWindow>
                )}
              </Marker>
            )}
            <Circle
              options={{
                strokeColor: 'transparent',
                fillColor: location.user ? 'red' : 'green',
                fillOpacity: 0.2
              }}
              center={{
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude)
              }}
              radius={location.radius}
            />
          </div>
        ))}
      {categories && (
        <SideMap categories={categories} setLocations={setLocations} />
      )}
    </GoogleMap>
  )
}

HeroLocations.propTypes = {
  data: PropTypes.object.isRequired
}

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_API_URL,
    loadingElement: <div style={{ height: `100vw` }} />,
    containerElement: (
      <div
        style={{
          height: `100vw`
        }}
      />
    ),
    mapElement: (
      <div
        style={{
          height: `100vw`
        }}
      />
    )
  }),
  withScriptjs,
  withGoogleMap
)(HeroLocations)
